import { Helmet } from "react-helmet-async";
import { useLanguage } from "@/lib/LanguageContext";
import Navbar from "@/components/Navbar";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

export default function ImpressumPage() {
  const { t } = useLanguage();

  return (
    <div data-testid="impressum-page" className="min-h-screen bg-[#FAFAFA]">
      <Helmet>
        <title>Impressum | Oona Flats</title>
        <meta name="description" content="Impressum und rechtliche Informationen - SharedSpace GmbH, Wien" />
      </Helmet>
      <Navbar />

      <div className="pt-28 pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <h1
              className="text-4xl md:text-5xl font-semibold tracking-tighter text-[#1D1D1F] mb-12"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Impressum
            </h1>
          </Reveal>

          <Reveal delay={150}>
          <div className="bg-white rounded-3xl border border-black/5 p-8 md:p-12 shadow-[0_8px_32px_rgba(0,0,0,0.04)] space-y-10">

            {/* Angaben gemäß § 5 ECG */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Angaben gemäß § 5 E-Commerce-Gesetz (ECG)
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p className="font-semibold text-lg">SharedSpace GmbH</p>
                <p>Cortigasse 19/5</p>
                <p>1220 Wien</p>
                <p>Österreich</p>
              </div>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Kontakt
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p>E-Mail: <a href="mailto:office@sharedspace-rentals.com" className="underline hover:text-[#86868B] transition-colors">office@sharedspace-rentals.com</a></p>
                <p>Web: <a href="https://oonaflats.com" className="underline hover:text-[#86868B] transition-colors">oonaflats.com</a></p>
              </div>
            </section>

            {/* Geschäftsführung */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Geschäftsführung
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p>Lukas Krämer</p>
                <p>Stephan Szentgyörgyi</p>
              </div>
            </section>

            {/* Firmenbuch */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Firmenbuchdaten
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p>Firmenbuchnummer: FN 626272 p</p>
                <p>Firmenbuchgericht: Handelsgericht Wien</p>
                <p>Rechtsform: Gesellschaft mit beschränkter Haftung (GmbH)</p>
              </div>
            </section>

            {/* UID */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Umsatzsteuer-Identifikationsnummer
              </h2>
              <div className="text-[#1D1D1F] text-base leading-relaxed">
                <p>UID-Nr.: ATU80794712</p>
              </div>
            </section>

            {/* Kammerzugehörigkeit */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Kammerzugehörigkeit
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p>Wirtschaftskammer Wien (WKO Wien)</p>
                <p>Fachgruppe: Hotellerie / Beherbergungsbetriebe</p>
              </div>
            </section>

            {/* Unternehmensgegenstand */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Unternehmensgegenstand
              </h2>
              <div className="text-[#1D1D1F] text-base leading-relaxed">
                <p>Vermietung von Ferienwohnungen</p>
              </div>
            </section>

            {/* Anwendbare Rechtsvorschriften */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Anwendbare Rechtsvorschriften
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p>Gewerbeordnung (GewO): <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#86868B] transition-colors">www.ris.bka.gv.at</a></p>
                <p>E-Commerce-Gesetz (ECG)</p>
                <p>Konsumentenschutzgesetz (KSchG)</p>
                <p>Fern- und Auswärtsgeschäfte-Gesetz (FAGG)</p>
              </div>
            </section>

            {/* Streitschlichtung */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Online-Streitbeilegung
              </h2>
              <div className="space-y-3 text-[#1D1D1F] text-base leading-relaxed">
                <p>
                  Verbraucher haben die Möglichkeit, Beschwerden an die Online-Streitbeilegungsplattform
                  der EU zu richten:{" "}
                  <a
                    href="https://ec.europa.eu/consumers/odr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-[#86868B] transition-colors"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p>
                  Sie können allfällige Beschwerden auch an die oben angegebene E-Mail-Adresse richten.
                </p>
              </div>
            </section>

            {/* Haftungsausschluss */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Haftungsausschluss
              </h2>
              <div className="space-y-3 text-[#1D1D1F] text-sm leading-relaxed text-[#86868B]">
                <p>
                  <strong className="text-[#1D1D1F]">Haftung für Inhalte:</strong> Die Inhalte unserer Seiten wurden mit größter
                  Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
                  können wir jedoch keine Gewähr übernehmen.
                </p>
                <p>
                  <strong className="text-[#1D1D1F]">Haftung für Links:</strong> Unser Angebot enthält Links zu externen Webseiten
                  Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
                  fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten
                  ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
                <p>
                  <strong className="text-[#1D1D1F]">Urheberrecht:</strong> Die durch die Seitenbetreiber erstellten Inhalte und
                  Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die
                  Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb
                  der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
                  Autors bzw. Erstellers.
                </p>
              </div>
            </section>

            {/* Medieninhaber gemäß § 25 MedienG */}
            <section>
              <h2 className="text-xs font-bold tracking-[0.15em] uppercase text-[#86868B] mb-4">
                Medieninhaber gemäß § 25 Mediengesetz
              </h2>
              <div className="space-y-1 text-[#1D1D1F] text-base leading-relaxed">
                <p className="font-semibold">SharedSpace GmbH</p>
                <p>Cortigasse 19/5, 1220 Wien</p>
                <p>Unternehmensgegenstand: Vermietung von Ferienwohnungen</p>
                <p>Grundlegende Richtung: Information über Ferienwohnungen und Buchungsmöglichkeiten in Wien</p>
              </div>
            </section>

          </div>
          </Reveal>
        </div>
      </div>

      <Footer />
    </div>
  );
}
